import classNames from 'classnames';
import { tabVariants } from './services';
import styles from './tab.module.scss';
import { Link } from 'react-router-dom';

export default function Tab({
  tab,
  isActive = false,
  variant = 'primary',
  uppercase = false,
  className = '',
  onSelect,
}) {
  const handleTabClick = (event) => {
    event.preventDefault();
    if (onSelect) {
      onSelect(tab);
    }
  };

  const classes = classNames(
    tabVariants({
      uppercase,
      variant,
      isActive,
    }),
    className,
  );

  return (
    <div>
      {tab.linkHref ? (
        <Link href={tab.linkHref} className={classes}>
          {tab.label}
        </Link>
      ) : (
        <button className={classes} type="button" onClick={handleTabClick}>
          {tab.icon}
          {tab.label}
        </button>
      )}
      {variant === 'underline' && <span className={styles.underlineBar} />}
    </div>
  );
}
